import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { ApplicationState } from '@/state/root.models'

import { RestApiService } from '@/services'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { BONUS_PROGRAMS } from './api.routes'

import ActionTypes from '../constants'
import { SaveBonusPayload, BonusResponse, BonusEngineState } from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const createBonusEngineThunk = createAsyncThunk(
  ActionTypes.CREATE_BONUS_ENGINE,
  async (payload: SaveBonusPayload, thunkAPI) => {
    thunkAPI.dispatch(setLoadingFullAction(true))
    try {
      restApiService.requestParams = {
        method: 'POST',
        endpoint: BONUS_PROGRAMS.CREATE_BONUS,
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      const response: BonusResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const createBonusEngineExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(createBonusEngineThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(createBonusEngineThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.currentBonus = payload._id ? payload : state.currentBonus
  })
}

export default createBonusEngineExtraReducer
